function combinaisonToRowCol(str) {
    switch (str) {
        case 'H1D1M1P1S0':
            return {row: 0, col: 1}
        case 'H2D2M2P2S0':
            return {row: 0, col: 2}
        case 'H3D3M3P3S0':
            return {row: 0, col: 3}
        case 'H4D4M4P4S0':
            return {row: 0, col: 4}
        case 'H5D5M5P5S0':
            return {row: 0, col: 5}
        case 'H6D6M6P6S0':
            return {row: 0, col: 6}
        case 'H7D7M7P7S0':
            return {row: 0, col: 7}
        case 'H8D8M8P8S0':
            return {row: 0, col: 8}
        case 'H1D1M1P1S1':
            return {row: 1, col: 1}
        case 'H2D2M2P2S1':
            return {row: 1, col: 2}
        case 'H3D3M3P3S1':
            return {row: 1, col: 3}
        case 'H4D4M4P4S1':
            return {row: 1, col: 4}
        case 'H5D5M5P5S1':
            return {row: 1, col: 5}
        case 'H6D6M6P6S1':
            return {row: 1, col: 6}
        case 'H7D7M7P7S1':
            return {row: 1, col: 7}
        case 'H8D8M8P8S1':
            return {row: 1, col: 8}
        default:
            console.error(`Combinaison ${str} inconnue`)
    }
}

function rowColToCombinaison(row, col) {
    return `H${col}D${col}M${col}P${col}S${row}`
}

export {
    combinaisonToRowCol,
    rowColToCombinaison
}
